module.exports = __webpack_public_path__ + "static/media/how-2.a26c4b1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/how-2.png
// module id = 352
// module chunks = 0